// extracted by mini-css-extract-plugin
export var grid = "PageCountry-module--grid--fpWWu";